import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StateListComponent } from './state-list/state-list.component';
import { StateCreateComponent } from './state-create/state-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: StateListComponent,
        data: {
          title: "State List",
          breadcrumb: "State List"
        }
      },
      {
        path: 'create',
        component: StateCreateComponent,
        data: {
          title: "Create State",
          breadcrumb: "Create State"
        }
      },
      {
        path: 'edit/:id',
        component: StateCreateComponent,
        data: {
          title: "Edit State",
          breadcrumb: "Edit State"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class StateRoutingModule { }
